import { Dashboard } from '@cxstudio/dashboards/entity/dashboard';

export class HomePageDashboard extends Dashboard {
	homePageId: number;
}